import {Card, CardBody, CardSubtitle, CardTitle} from "reactstrap";
import React from "react";

interface CardOfficeProps {
    name: string;
    prefix: string;
}

const CardOffice: React.FC<CardOfficeProps> = ({name, prefix}) => {
    return (
        <Card className="text-center">
            <CardBody>
                <CardSubtitle className="mb-2 text-muted" tag="span">
                    Name
                </CardSubtitle>
                <CardTitle className="font-size-20 fw-bold" tag="h4">
                    {name}
                </CardTitle>

                <CardSubtitle className="mb-2 text-muted" tag="span">
                    Prefix
                </CardSubtitle>
                <CardTitle className="mb-0" tag="h4">
                    {prefix}
                </CardTitle>
            </CardBody>
        </Card>
    )
}

export default CardOffice;